export { SecondType } from "./second-type";
